export default {
    en: {
        title: 'Add seller',
        form: {
            name: 'Store Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            phone: 'Phone Number',
            address: 'Store Address',
            language: 'Language',
            storeCurrency: 'Currency',
            email: 'Email',
            password: 'Password',
            authBtn: 'Security',
            authUpdateBtn: 'Update Security',
            updateBtn: 'Save Changes',
        },
        note: 'If you want to change your info',
        editBtn: 'Edit',
        sellers: {
            title: 'Sellers List',
            btn: 'Add Seller',
            tName: 'Name',
            tPhone: 'Phone',
            tEmail: 'Email',
            tPassword: 'Password',
            actions: 'Actions'
        },
        messages: {
            editImg: 'The image has been saved successfully',
            editForm: 'The Information has been saved successfully'
        }

    },
    uz: {
        title: "Do'kon profili",
        form: {
            name: "Do'kon Nomi",
            firstName: 'Ismingiz',
            lastName: 'Familiyangiz',
            phone: "Telefon raqam",
            address: "Do'kon Manzili",
            language: 'Til',
            storeCurrency: "To'lov birligi",
            email: 'Email',
            password: 'Parol',
            authBtn: 'Xavfsizlik',
            authUpdateBtn: 'Xavfsizlikni Yangilash',
            updateBtn: 'Saqlash',
        },
        note: "Agar ma'lumotingizni o'zgartirishni xohlasangiz",
        editBtn: 'Tahrirlash',
        sellers: {
            title: "Sotuvchilar ro'yxati",
            btn: "Sotuvchi qo'shish",
            tName: "Ism",
            tPhone: "Telefon",
            tEmail: 'Email',
            tPassword: 'Parol',
            actions: 'Vazifalar'
        },
        messages: {
            editImg: "Rasm muvaffaqiyatli saqlandi",
            editForm: "Ma'lumot muvaffaqiyatli saqlandi"
        }

    },
    ru: {
        title: 'Профиль магазина',
        form: {
            name: 'Название магазина',
            firstName: 'Имя',
            lastName: 'Фамилия',
            phone: 'Номер телефона',
            address: 'Адрес магазина',
            language: 'Язык',
            storeCurrency: 'Валюта',
            email: 'Email',
            password: 'Пароль',
            authBtn: 'Безопасность',
            authUpdateBtn: 'Обновление Безопасность',
            updateBtn: 'Сохранить',
        },
        note: 'Если вы хотите изменить свою информацию',
        editBtn: 'Редактировать',
        sellers: {
            title: 'Список продавцов',
            btn: 'Добавить продавца',
            tName: 'ФИО',
            tPhone: 'Телефон',
            tEmail: 'Email',
            tPassword: 'Пароль',
            actions: 'Задачи'
        },
        messages: {
            editImg: 'Изображение было успешно сохранено',
            editForm: 'Информация была успешно сохранена'
        }

    }
}